export default {
  "title": {
    "travels": "Viagens",
    "mainIndicators": "Principais indicadores comportamentais",
    "dailyBehaviorGrade": "Nota comportamental diária",
    "travelDetail": "Detalhe da nota comportamental da viagem",
    "travelMainIndicators": "Indicadores de viagem",
    "drivers": "motoristas",
    "driverSleeps": "Eventos de sonolência",
    "team": "VEÍCULO"
  },
  "labels": {
    "behaviorGrade": "Nota comportamental",
    "average": "Média"
  },
  "graphTooltip": {
    "behaviorGrade": "Dia da nota"
  },
  "buttons": {
    "travelDetail": "Detalhe da viagem"
  },
  "table": {
    "travel": "Viagem",
    "grade": "Nota comportamental"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/behavior/driverBehavior.js